import { render, staticRenderFns } from "./DataConversionNTC.vue?vue&type=template&id=7bf5fb18&scoped=true&"
import script from "./DataConversionNTC.vue?vue&type=script&lang=js&"
export * from "./DataConversionNTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5fb18",
  null
  
)

/* custom blocks */
import block0 from "./DataConversionNTC.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports